import { Component, OnInit, AfterViewInit, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import {Subscription, combineLatest, interval} from 'rxjs';
import { SiteService} from '../../../../services/index';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'angular-highcharts';
import {AppUtils, Constants, Highcharts$, WarningDialog} from '../../../../shared/index';
import { Hierarchy, FeatureItemFlatNode, FeatureItemNode } from '../../../../models/index';
import * as ObjectUtils from 'util';
import { MatDialog } from '@angular/material';
@Component({
  selector: 'app-meter-view',
  templateUrl: './meter-view.component.html',
  styleUrls: ['./meter-view.component.scss']
})
export class MeterViewComponent extends Hierarchy implements OnInit, AfterViewInit, OnDestroy  {
  // tslint:disable-next-line:member-ordering
  @ViewChild('tree') tree;
  siteId: string;
  isST_load: boolean; isMeter: undefined | boolean = undefined;
  isFirstLoaded = true;
  alive = true;
  realtimePowerChart: Chart; voltageChart: Chart; currentChart: Chart; powerFactorChart: Chart;
  realtimePowerChartOption: any; voltageChartOption: any; currentChartOption: any; powerFactorChartOption: any;
  realtimepowerUnit = 'kW'; voltageUnit = 'V'; currentUnit = 'Amperes'; powerfactorUnit = 'Ratio';
  colorGreen = '#55BF3B';
  colorYellow = '#DDDF0D';
  colorRed = '#DF5353';
  showMeterViewCharts = false;
  loadName = '';
  txtime = '';
  currentNode: { nodeData: any, metersId: any, nodeTitle: string,
    nodeType: string, loadId: string; meterId: string, loadRId: string, kwRating: any } = Object.assign({});
    subscription: Subscription;
    public intervallTimer = interval(60 * 4 * 1000);
    constructor(private activeRoute: ActivatedRoute,
    private siteService: SiteService,
    private cd: ChangeDetectorRef,
    public dialog: MatDialog) {
    super();
    this.initChartOption();
    this.subscription = new Subscription();
   }

  ngOnInit() {
       // Combine them both into a single observable
  const urlParams = combineLatest(
    this.activeRoute.params,
    this.activeRoute.queryParams,
    (params, queryParams) => ({ ...params, ...queryParams})
  );
  // Subscribe to the single observable, giving us both
  urlParams.subscribe(routeParams => {
      this.siteId = routeParams.siteId;
      this.siteService.getTreeConfiguration(this.siteId, ['treeData']).subscribe(treeConfig => {
        this.dataSource.data = [];
        if (treeConfig !== undefined && treeConfig.treeData !== undefined) {
          // Data api is wrong. Can not use checkbox
          const dataPaser = JSON.parse(treeConfig.treeData);
          this.dataSource.data = this.buildFileTree(dataPaser[0], this.dataSource.data, null);
          this.tree.treeControl.expandAll();
          this.getFirstLoad(this.dataSource.data);
          this.processDataAndDrawChart();
        }
      });
  });
  }
  ngAfterViewInit(): void {
    this.tree.treeControl.expandAll();
    this.cd.detectChanges();
  }
  ngOnDestroy() {
    this.unsubscribeIntervall(false);
  }
  private unsubscribeIntervall = (alive: boolean) => {
    if (this.subscription) {
      this.alive = alive;
      this.subscription.unsubscribe();
    }
  }
  buildFileTree(obj: any, nodes: FeatureItemNode[], currentSelected: FeatureItemFlatNode): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.title = obj.title;
    node.id = obj.id;
    node.nodeType = obj.nodeType;
    node.subType = obj.subType;
    node.processRId = obj.processRId !== undefined ? obj.processRId : 'NA';
    node.meterId = obj.meterId !== undefined ?  obj.meterId : 'NA';
    node.loadId = obj.loadId !== undefined ?  obj.loadId : 'NA';
    node.loadRId = obj.loadRId !== undefined ?  obj.loadRId : 'NA';
    node.kwRating = obj.kwRating;
    // node.selected = obj.state.selected;
    if (currentSelected != null && currentSelected.id === obj.id) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      obj.nodes.forEach(element => {
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      });
    }
    return nodes.concat(node);
  }
  /** Toggle the feature item selection. Select/deselect all the descendants node */
  public featureItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.unsubscribeIntervall(true);
    this.setCurrentNode(node);
    this.processDataAndDrawChart();
  }
/** Toggle a leaf feature item selection. Check all the parents to see if they changed */
  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    this.unsubscribeIntervall(true);
    this.setCurrentNode(node);
    this.processDataAndDrawChart();
  }
  private getAllMetersIdOfNode = (node: any, metersId: any) => {
    if (node.meterId !== 'NA' ) {
      metersId.push(node.meterId);
    }
    if (node.nodes !== undefined && node.nodes.length > 0) {
    for (let i = 0; i < node.nodes.length; i++) {
      metersId = this.getAllMetersIdOfNode(node.nodes[i], metersId);
    }
    }
    return metersId;
  }
  private getFirstLoad = (tree: any) => {
    const firstLeaf = this.getFirstLeafOfTree(tree);
    if (typeof(firstLeaf.is_ST_Load) !== 'undefined' && firstLeaf.is_ST_Load != null && firstLeaf.is_ST_Load) {
      this.isST_load = true;
    } else {
        this.isST_load = false;
    }
    this.setCurrentNode(firstLeaf);
    const node = document.getElementById(firstLeaf.title);
    node.dispatchEvent(new Event('click'));
  }
  private getFirstLeafOfTree = (tree: any, conditions: any = undefined) => {
    let result;
    if (tree !== undefined) {
      for (let i = 0; i < tree.length; i++) {
        if (this.hasChildNode(tree[i])) {
          result = this.getFirstLeafOfTree(tree[i].nodes, conditions);
        } else {
          let conditionEvaluated = true;
          if (conditions !== undefined) {
            const propNames = Object.keys(conditions);
            for (let j = 0; j < propNames.length; j++) {
              conditionEvaluated = conditionEvaluated && tree[i][propNames[j]] === conditions[propNames[j]];
              if (conditionEvaluated === false) {
                break;
              }
            }
          }
          if (tree[i].loadId !== undefined && conditionEvaluated) {
            result = tree[i];
            break;
          } else {
            continue;
          }
        }
        if (result !== undefined) {
          break;
        }
      }
    }
    return result;
  }
  private hasChildNode = (branch: any): boolean => {
    return (branch.nodes === undefined || branch.nodes.length === 0) ? false : true;
  }
  private setCurrentNode = (node: FeatureItemNode | FeatureItemFlatNode) => {
    this.isST_load = true;
    if (node.nodeType === Constants.NODE_TYPE.METER) {
      this.isST_load = false;
    } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
      this.isST_load = false;
      if (node.subType !== undefined && node.subType === 'StratificationTank') {
        this.isST_load = true;
      }
    }
    if (this.isST_load){
      this.onOpenAlertBox('Please choose any relevant load to view real time data.');
    } else {
      this.currentNode.nodeData = node;
      const metersId = this.getAllMetersIdOfNode(node, []);
      this.currentNode.metersId = AppUtils.uniqueArray(metersId);
      this.currentNode.nodeTitle = node.title;
      this.currentNode.nodeType = node.nodeType;
      if (node.nodeType === Constants.NODE_TYPE.METER) {
        this.isMeter = true;
        this.currentNode.meterId = node.meterId;
        this.currentNode.loadId = node.meterId;
        this.isST_load = false;
      } else if (node.nodeType === Constants.NODE_TYPE.LOAD) {
        this.isMeter = false;
        this.isST_load = false;
        this.currentNode.meterId = node.meterId;
        this.currentNode.loadId = node.loadId;
        this.currentNode.loadRId = node.loadRId;
        this.currentNode.kwRating = node.kwRating;
        if (node.subType !== undefined && node.subType === 'StratificationTank') {
          this.isST_load = true;
        }
      }
    }
  }
  private processDataAndDrawChart = () => {
    this.setChartOptionByKwRating();
    if (this.isST_load === false) {
      this.isFirstLoaded = false;
      if (this.isMeter) {
        this.getLastRealtimeData(this.currentNode.loadId);
      } else {
        this.siteService.getMeterOfLoad(this.siteId, this.currentNode.loadId).subscribe(data => {
          this.getLastRealtimeData(data.meterId);
        });
      }
    }
  }
  private getLastRealtimeData = (meterId: any) => {
    this.siteService.getLastRealtimeDataForLoadOfMeterView(this.siteId, meterId).subscribe(data => {
      this.txtime = data.txtime;
      const realtimepower = ObjectUtils.isNullOrUndefined(data.realtimepower) ? 0 : data.realtimepower;
      const voltage = ObjectUtils.isNullOrUndefined(data.voltage) ? 0 : data.voltage;
      const current = ObjectUtils.isNullOrUndefined(data.current) ? 0 : data.current;
      const powerfactor = ObjectUtils.isNullOrUndefined(data.powerfactor) ? 0 : data.powerfactor;
      this.realtimePowerChartOption.series[0].data[0] = realtimepower;
      this.voltageChartOption.series[0].data[0] = voltage;
      this.currentChartOption.series[0].data[0] = current;
      this.powerFactorChartOption.series[0].data[0] = powerfactor;
      // this.realtimePowerChartOption.series[0].data[0] = realtimepower;
      // this.voltageChartOption.series[0].data[0] = 40;
      // this.currentChartOption.series[0].data[0] = 90;
      // this.powerFactorChartOption.series[0].data[0] = 0.2;
      //
      this.realtimePowerChart = new Chart(this.realtimePowerChartOption);
      this.voltageChart = new Chart(this.voltageChartOption);
      this.currentChart = new Chart(this.currentChartOption);
      this.powerFactorChart = new Chart(this.powerFactorChartOption);
    });
    this.subscription = this.intervallTimer.subscribe(() => {
      if (this.alive) {
        this.siteService.getLastRealtimeDataForLoadOfMeterView(this.siteId, meterId).subscribe(data => {
          this.txtime = data.txtime;
          const realtimepower = ObjectUtils.isNullOrUndefined(data.realtimepower) ? 0 : data.realtimepower;
          this.realtimePowerChart.ref.series[0].points[0].update(realtimepower);
          const voltage = ObjectUtils.isNullOrUndefined(data.voltage) ? 0 : data.voltage;
          this.voltageChart.ref.series[0].points[0].update(voltage);
          const current = ObjectUtils.isNullOrUndefined(data.current) ? 0 : data.current;
          this.currentChart.ref.series[0].points[0].update(current);
          const powerfactor = ObjectUtils.isNullOrUndefined(data.powerfactor) ? 0 : data.powerfactor;
          this.powerFactorChart.ref.series[0].points[0].update(powerfactor);
        });
      } else {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });

  }
  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%'});
    dialogRef.componentInstance.confirmMessage = description;
  }
  private initChartOption = () => {
    this.realtimePowerChartOption = this.viewMeterHC();
    this.voltageChartOption = this.viewMeterHC();
    this.currentChartOption = this.viewMeterHC();
    this.powerFactorChartOption = this.viewMeterHC();
    //
    this.realtimePowerChartOption.title.text = 'Realtime Power';
    this.voltageChartOption.title.text = 'Voltage';
    this.currentChartOption.title.text = 'Current';
    this.powerFactorChartOption.title.text = 'Power Factor';
    //
    this.realtimePowerChartOption.yAxis.title.text = this.realtimepowerUnit;
    this.voltageChartOption.yAxis.title.text = this.voltageUnit;
    this.currentChartOption.yAxis.title.text = this.currentUnit;
    this.powerFactorChartOption.yAxis.title.text = this.powerfactorUnit;
    //
    this.realtimePowerChartOption.series[0].name = ' ' + 'Realtime Power';
    this.voltageChartOption.series[0].name = ' ' + 'Voltage';
    this.currentChartOption.series[0].name = ' ' + 'Current';
    this.powerFactorChartOption.series[0].name = ' ' + 'Power Factor';
    //
    this.realtimePowerChartOption.series[0].tooltip.valueSuffix = ' ' + this.realtimepowerUnit;
    this.voltageChartOption.series[0].tooltip.valueSuffix = ' ' + this.voltageUnit;
    this.currentChartOption.series[0].tooltip.valueSuffix = ' ' + this.currentUnit;
    this.powerFactorChartOption.series[0].tooltip.valueSuffix = ' ' + this.powerfactorUnit;
    //
    this.realtimePowerChartOption.yAxis.min = 0;
    this.voltageChartOption.yAxis.min = 0;
    this.currentChartOption.yAxis.min = 0;
    this.powerFactorChartOption.yAxis.min = -1;
    //
    this.realtimePowerChartOption.yAxis.max = 200;
    this.voltageChartOption.yAxis.max = 450;
    this.currentChartOption.yAxis.max = 500;
    this.powerFactorChartOption.yAxis.max = 1;
    //
    this.voltageChartOption.yAxis.plotBands = [{
      from: 0,
      to: 420,
      color: this.colorGreen
    }, {
      from: 420,
      to: 450,
      color: this.colorRed
     }];
    this.powerFactorChartOption.yAxis.plotBands = [{
       from: -1,
       to: 0.8,
       color: this.colorYellow
      }, {
        from: 0.8,
        to: 1,
        color: this.colorGreen
    }];
  }
  private setChartOptionByKwRating = () => {
    const kwRating = this.currentNode.kwRating;
    this.realtimePowerChartOption.yAxis.max = 2 * kwRating;
    this.currentChartOption.yAxis.max = 2 * kwRating;
    const tempToPlotBand = kwRating * 0.80 * 2;
    const tempFromPlotBand = kwRating * 0.95 * 2;
    this.realtimePowerChartOption.yAxis.plotBands = [{
      from: 0,
       to: tempToPlotBand,
       color: this.colorGreen
      }, {
          from: tempToPlotBand,
          to: tempFromPlotBand,
          color: this.colorYellow
      }, {
          from: tempFromPlotBand,
          to: 2 * kwRating,
          color: this.colorRed
      }];
    this.currentChartOption.yAxis.plotBands = [{
      from: 0,
       to: tempToPlotBand,
       color: this.colorGreen
   }, {
       from: tempToPlotBand,
       to: tempFromPlotBand,
       color: this.colorYellow
   }, {
       from: tempFromPlotBand,
       to: 2 * kwRating ,
       color: this.colorRed
   }];
  }
  private viewMeterHC = () => {
    return  {
      chart: {
        type : 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        marginTop: 30,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 0,
      },
      title : {
        style: {'fontSize': '16px'}
      },
      pane: {
        startAngle: -150,
            endAngle: 150,
            background: [{
                backgroundColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, '#FFF'],
                        [1, '#333']
                    ]
                },
                borderWidth: 0,
                outerRadius: '109%'
            }, {
                backgroundColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, '#333'],
                        [1, '#FFF']
                    ]
                },
                borderWidth: 1,
                outerRadius: '107%'
            }, {
              // default background
          }, {
                backgroundColor: '#DDD',
                borderWidth: 0,
                outerRadius: '105%',
                innerRadius: '103%'
            }]
        },
      credits : {
        enabled : false
      },
      yAxis: {
        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',
        tickPixelInterval: 30,
        tickWidth: 2,
        tickPosition: 'inside',
        tickLength: 10,
        tickColor: '#666',
        labels: {
          step: 2,
          rotation: 'auto'
        },
        title: { text: ''},
        max: 0,
        min: 0,
        plotBands: []
      },
      series: [{
        name: '',
        data: [0],
        dataLabels: {
          formatter : function() {
            return Highcharts$.numberFormat(this.y, Constants.DECIMAL_FORMAT.SOLAR_DECIMAL_NO);
            }
        },
        tooltip: {
            valueSuffix: '',
        }
        }]
    };
  }
}
